module.exports = __webpack_public_path__ + "static/recycledtoys-bcc3eabb8e4bf00b2ad88e30f8aefad4.png";